/**
 * Vide le cache local de l'application (localStorage).
 * Ne supprime pas le JWT ni la préférence sidebar pour garder la session et l'UI.
 */
export function clearAppCache() {
  if (typeof window === 'undefined' || !window.localStorage) return;
  const keysToRemove = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (
      key.startsWith('reference_pages_') ||
      key.startsWith('seo-reco-') ||
      key.startsWith('file_') ||
      key === 'pub_session_id'
    ) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach((k) => localStorage.removeItem(k));
  return keysToRemove.length;
}
